import styles from './index.less'
import { useEffect, useRef, useState } from 'react'
import { LOGIN_QR_CODE_BASE_URL } from '@/constants'
import * as API from '../../api'
import { WxQRCodeStatus } from './const'
import { addCookie, deleteCookie, getCookie } from '@/utils/cookie'
import { setHeaders } from '@/utils/request'
import { openPopDialog } from '@/components/RewordPop'
import {  setShowRewardPop, useStore } from '@/states/store'
import RprmUtils from '@/utils/dot'
import { getQuery } from '@/utils'
import { WechatScanType } from '@/pages/personalCenter/components/AccountMgt/config'
import { getUserInfo } from '@/utils/getUserInfo'
interface IProps {
  bindTel: Function
  onLogin?: Function
  closeDialog?: Function
}
export default ({ onLogin, bindTel, closeDialog }: IProps) => {
  const [qrCodeUrl, setQRCodeUrl] = useState('')

  const [overdule, setOverdule] = useState(true)

  const timer = useRef<any>(null)

  const ticket = useRef('')

  const query = getQuery()
  const { userInfo } = useStore()
  // 长轮询判断扫码状态
  const loopLoginStatus = async () => {
    const { data } = await API.login({
      loginType: 1,
      qrCodeTicket: ticket.current,
      shareCode:query.shareCode
    })
    if (data!.wxQrCodeStatus === WxQRCodeStatus.未关注) {
    } else if (data!.wxQrCodeStatus === WxQRCodeStatus.已过期) {
      setOverdule(true)
      clearInterval(timer.current)
      return
    } else if (data!.wxQrCodeStatus === WxQRCodeStatus.已关注) {
      // 1.0.1 手动打点
      if (!data?.token) {
        RprmUtils.rec(`scan_qr_code`, 'view', { en: 'tap', et: 'custom' })
      }
      if (data!.token) {
        addCookie('token', data!.token, 24 * 30)
        addCookie('userId', data!.userId, 24 * 30)
        setHeaders()
        clearInterval(timer.current)
        if (data!.isPopup) {
          setShowRewardPop(true)
          openPopDialog()
        }
        onLogin?.()
        return
      }

      if (!data!.isBindPhone) {
        bindTel({
          ticket: ticket.current,
        })
      }

      return
    }
  }


    const loogFetch = async() => {
      API.bindWeChat(ticket.current).then(async(res:any) => {
        if (res.data.wxQrCodeStatus === WechatScanType.已过期) {
          clearInterval(timer.current)
          setOverdule(true)
        } else if (res.data.wxQrCodeStatus === WechatScanType.已关注) {
          clearInterval(timer.current)
          onLogin?.()
        }
      }).catch(() => {
        clearInterval(timer.current)
      })
    }

  // 获取ticket并获取qrCode
  const getTicketAndQRCode = () => {
    setOverdule(false)
    API.getWechatQRCode().then((res: any) => {
      setQRCodeUrl(LOGIN_QR_CODE_BASE_URL + res.data.qrCodeTicket)
      ticket.current = res.data.qrCodeTicket
      if (ticket.current) {
        if(getCookie('token')&&userInfo?.channelType=== 2){
          timer.current = setInterval(() => {
            loogFetch()
          }, 3000)
        }else{
          timer.current = setInterval(() => {
            loopLoginStatus()
          }, 3000)
        }

      }
    })
  }

  useEffect(() => {
    getTicketAndQRCode()
    return () => {
      clearInterval(timer.current)
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>微信扫码 一键登录</p>
      <div className={styles.qrCode}>
        {qrCodeUrl && <img src={qrCodeUrl} />}
        {overdule && (
          <div onClick={getTicketAndQRCode} className={styles.overduleMask}>
            <div className={'icon-rotate'}></div>
            <p>刷新二维码</p>
          </div>
        )}
        <span className={styles.tip}>登录免费领取<span className={styles.number}>200</span>微力</span>
      </div>
      <div className={styles.tips}>
        <img src={'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/dengluyeweixinsaoma.png'} />
        微信扫一扫
      </div>
    </div>
  )
}
